// Error Handling
import { HttpClientModule } from "@angular/common/http";
import { ApolloModule, APOLLO_OPTIONS } from "apollo-angular";
import { HttpLink } from "apollo-angular/http";
import { InMemoryCache } from "apollo-cache-inmemory";
import { NgModule } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { EffectsModule } from "@ngrx/effects";
import { Action, MetaReducer, StoreModule } from "@ngrx/store";
import { StoreDevtoolsModule } from "@ngrx/store-devtools";
import { ErrorHandlerModule } from "@orthofi/ngx-error-handler";
// Other
import { SentryLoggingModule } from "@orthofi/ngx-sentry";
import { environment } from "src/environments/environment";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
// Modules
import { CoreModule } from "./core/core.module";
import { indexLogger } from "./modules/treatment-create/store/reducer-index";
import { SharedModule } from "./shared/shared.module";

/**
 * Similar to middleware, these meta reducers are an array of items to hook in
 * to the NgRx action->reducer pipeline.
 */
const metaReducers: MetaReducer<unknown, Action>[] = !environment.production
  ? [indexLogger]
  : [];

/**
 * The main application module containing the core module, shared module, and any feature modules.
 * initialized, the main application component will be created.
 */
@NgModule( {
  declarations: [AppComponent],
  imports: [
    // Modules
    CoreModule,
    SharedModule, // Error Handling
    ErrorHandlerModule.forRoot(),
    SentryLoggingModule.forRoot(),

    // App Routing must be imported last
    AppRoutingModule,
    StoreModule.forRoot( {}, { metaReducers } ),
    EffectsModule.forRoot(),
    StoreDevtoolsModule.instrument( {
      maxAge: 25, // Retains last 25 states
      logOnly: environment.production, // Restrict extension to log-only mode
    } ),
    HttpClientModule,
    ApolloModule
  ],
  providers: [
    Title,
    { provide: "ENV", useValue: environment }, // Error Handling:
    {
      provide: "ERROR_HANDLER_OPTIONS",
      useValue: environment.errorHandlerOptions,
    },
    {
      provide: "ERROR_LOGGER_OPTIONS",
      useValue: environment.errorLoggerOptions,
    }, // Other
    { provide: "AUTHENTICATION_API", useValue: environment.authenticationApi },
    {
      provide: "PORTAL_URL",
      useValue: environment.portalUrl,
    },
    {
      provide: APOLLO_OPTIONS,
      useFactory: ( httpLink: HttpLink ) => {
        return {
          cache: new InMemoryCache(),
          link: httpLink.create( {
            uri: environment.gatewayApi,
            withCredentials: true,
          } )
        }
      },
      deps: [HttpLink]
    }
  ],
  bootstrap: [AppComponent],
} )
export class AppModule { }
